import React, { useEffect, useState } from "react"

import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"

import * as styles from "./testimonials.module.scss"
import Heading from "../../atoms/heading"

const Testimonials = ({ quotes, title, color, small }) => {
  const { sanitySettings } = useStaticQuery(graphql`
    {
      sanitySettings {
        testimonials {
          testimonials
          title
        }
      }
    }
  `)
  const [activeSlide, setActiveSlide] = useState(0)
  const slides = quotes || sanitySettings.testimonials.testimonials
  const headline = title || sanitySettings.testimonials.title

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveSlide((prevSlide) =>
        prevSlide >= slides.length - 1 ? 0 : prevSlide + 1
      )
    }, 10000)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  const testimonials = slides.map((item, index) => (
    <div
      key={item.quote || item}
      className={`${styles.card} ${
        index === activeSlide ? styles.activeCard : ""
      }`}
    >
      <Heading level="2">{item.quote || item}</Heading>
      {item.attribution ? (
        <Heading level={6}>— {item.attribution}</Heading>
      ) : (
        ""
      )}
    </div>
  ))

  return (
    <div
      className={`${styles.testimonials} ${small ? styles.testimonials__small : ""} ${styles[`testimonials__${color?.replaceAll("-", "") || "emerald"}`]}`}
    >
      <Heading semantic={false} level="5" className={styles.title}>
        {headline}
      </Heading>
      <div className={styles.cards}>{testimonials}</div>
    </div>
  )
}

export default Testimonials

Testimonials.propTypes = {
  quotes: PropTypes.array,
  title: PropTypes.string,
  color: PropTypes.string,
  small: PropTypes.bool,
}

Testimonials.defaultProps = {
  quotes: null,
  title: "",
  color: "emerald",
  small: false,
}
